import produce from 'immer';
import {
  INVENTORY_TRANSACTIONLOG_LIST_REQUEST,
  INVENTORY_TRANSACTIONLOG_LIST,
  SET_TOTAL_COUNT,
  SET_INVENTORY_TRANSACTIONLOG_PAGINATION,
  INVENTORY_TRANSACTIONLOG_PAGE_RESET,
  ITEM_TRANSACTION_LOG_LIST_REQUEST,
} from '../../constants/log/inventoryTransactionLogConstants';
import moment from 'moment';

const initialState = {
  page: 1,
  pageLength: 10,
  beginDate: moment().utc().subtract(3, 'days').format('YYYY-MM-DDT00:00:00'),
  endDate: moment().utc().format('YYYY-MM-DDT23:59:59'),
  searchCode: '',
  searchString: '',
  totalCount: 0,
};

const inventoryTransactionLogReducer = (state = initialState, action = {}) => produce(state, draft => {
  switch (action.type) {
    case INVENTORY_TRANSACTIONLOG_LIST_REQUEST:
      break;
    case INVENTORY_TRANSACTIONLOG_LIST:
      draft.list = action.list;
      break;
    case SET_TOTAL_COUNT:
      draft.totalCount = action.totalCount;
      break;
    case SET_INVENTORY_TRANSACTIONLOG_PAGINATION:
      draft.page = action.page;
      draft.totalCount = action.totalCount;
      draft.beginDate = action.beginDate;
      draft.endDate = action.endDate;
      draft.searchCode = action.searchCode;
      draft.searchString = action.searchString;
      break;
    case INVENTORY_TRANSACTIONLOG_PAGE_RESET:
      draft.page = 1;
      break;
    case ITEM_TRANSACTION_LOG_LIST_REQUEST:
      break;
    default:
      break;
  }
});

export default inventoryTransactionLogReducer;
